import React from 'react';
import './OverlayLoader.css';
import { LoadingBounce } from '@michelin/acid-components';

type OverlayLoaderProps = {
  show: boolean;
};

export const OverlayLoader: React.FC<OverlayLoaderProps> = ({ show }) => {
  if (!show) return null;

  return (
    <div className="loading-overlay">
      <LoadingBounce style={{ height: 100 }} />
    </div>
  );
};
